export default __webpack_public_path__ + "static/media/product_01.975628b9.png";